import to from 'await-to-js';
import OKA from '../';

export default {
    GetBlockBulk: (data) => new Promise(async(resolve, reject) => {
        if (!OKA.http.locale) reject(false);
        const [err, response] = await to(OKA.http.locale.get('/static/get/bulk', {
            params: data
        }));
        if (err) {
            reject(err)
        }

        resolve(response);
    }),

    GetInit: async(params) => {
        // console.table(params)
        if (!OKA.http.locale) throw new Error('url not initialized');
        const [err, response] = await to(OKA.http.locale.get('/appservice/init', {
            params
        }));
        if (err) {
            throw err;
        }

        return response;
    }
};